export default __webpack_public_path__ + "static/media/candle_bg.d3e4ce21.jpg";